import SmallCardProject from "../../project/overview/SmallCardProject";
import React, {useEffect, useRef, useState} from "react";
import styled from "styled-components";
import AxisContainer from "./AxisContainer";
import {useSelector} from "react-redux";

const Projects = ({sections}) => {

    const [axisSelected, setAxisSelected] = useState(0)
    const [selectedSection, setSelectedSection] = useState({})
    

    useEffect(() => {
        let selectedSection = sections.filter(s => s.state === true)[0] || {}
        if (Object.keys(selectedSection).length > 0) {
            setSelectedSection(selectedSection)
        }
    }, [sections])


    const {projects} = useSelector(state => state.projects)
    const [projectsSelected, setProjectsSelected] = useState(projects || [])
    const nonStartedProjectColumn = useRef()
    const startedProjectColumn = useRef()
    const finishedProjectColumn = useRef()

    const returnRatioOfProject = (ref) => {
        if (ref === nonStartedProjectColumn) {
            return (
                `${projectsSelected.filter(p => p.advancement === 0).length} / ${projectsSelected.length}`
            )
        } else if (ref === startedProjectColumn) {
            return (
                `${projectsSelected.filter(p => p.advancement < 100).filter(p => p.advancement > 0).length} / ${projectsSelected.length}`
            )
        } else if (ref === finishedProjectColumn) {
            return (
                `${projectsSelected.filter(p => p.advancement === 100).length} / ${projectsSelected.length}`
            )
        }
    }

    const returnTitle = (ref) => {
        if (ref === nonStartedProjectColumn) {
            return (
                projects.filter(p => p.advancement === 0).length === 0 ||
                projects.filter(p => p.advancement === 0).length === 1 ?
                    `Projet non commencé - ${returnRatioOfProject(ref)}` : `Projets non commencés - ${returnRatioOfProject(ref)}`

            )
        } else if (ref === startedProjectColumn) {
            return (
                projects
                    .filter(p => p.advancement < 100)
                    .filter(p => p.advancement > 0).length === 0 ||
                projects
                    .filter(p => p.advancement < 100)
                    .filter(p => p.advancement > 0).length === 1

                    ? `Projet commencé - ${returnRatioOfProject(ref)}` : `Projets commencés ${returnRatioOfProject(ref)}`
            )
        } else if (ref === finishedProjectColumn) {
            return (
                projects
                    .filter(p => p.advancement === 100).length === 0 ||
                projects
                    .filter(p => p.advancement === 100).length === 1 ?
                    `Projet terminé - ${returnRatioOfProject(ref)}` : `Projets terminés ${returnRatioOfProject(ref)}`
            )
        }
    }

    return (
        <>
               <AxisContainer
                setProjectsSelected={setProjectsSelected}
                selectedSection={selectedSection}
                axisSelected={axisSelected}
                setAxisSelected={setAxisSelected}
            />

            <ProjectsContainer>
                {projectsSelected.length === 0 ?
                    <h1 id={"roadmap-h1"}> Pas de projets avec cette sélection </h1>
                    :
                    <>
                        <ProjectColumns>
                            <h2>
                                {returnTitle(nonStartedProjectColumn)}
                            </h2>
                            {projectsSelected
                                .filter(p => p.advancement === 0)
                                .map(p =>
                                    <SmallCardProject
                                        projectId={p.id}
                                        name={p.name}
                                        pilot={p.pilot}
                                        weather={p.weather}
                                        advancement={p.advancement}
                                        lastUpdate={p.lastUpdate}
                                        endDate={p.endDate}
                                        startDate={p.startDate}
                                        confidential={p.confidential}
                                    />
                                )}

                        </ProjectColumns>
                        <ProjectColumns>
                            <h2>
                                {returnTitle(startedProjectColumn)}
                            </h2>
                            {projectsSelected
                                .filter(p => p.advancement < 100)
                                .filter(p => p.advancement > 0)
                                .map(p =>
                                    <SmallCardProject
                                        projectId={p.id}
                                        name={p.name}
                                        pilot={p.pilot}
                                        weather={p.weather}
                                        advancement={p.advancement}
                                        lastUpdate={p.lastUpdate}
                                        endDate={p.endDate}
                                        startDate={p.startDate}
                                        confidential={p.confidential}
                                    />
                                )}

                        </ProjectColumns>
                        <ProjectColumns>
                            <h2>
                                {returnTitle(finishedProjectColumn)}
                            </h2>
                            {projectsSelected
                                .filter(p => p.advancement === 100)
                                .map(p =>
                                    <SmallCardProject
                                        projectId={p.id}
                                        name={p.name}
                                        pilot={p.pilot}
                                        weather={p.weather}
                                        advancement={p.advancement}
                                        lastUpdate={p.lastUpdate}
                                        endDate={p.endDate}
                                        startDate={p.startDate}
                                        confidential={p.confidential}
                                    />
                                )}
                        </ProjectColumns>
                    </>
                }
            </ProjectsContainer>
        </>

    )
}

const ProjectsContainer = styled.div`
  display: flex;
  flex-direction: column;

  h2 {
    margin-top: 1em;
  }

  @media (min-width: 900px) {
    margin-top: 3em;
    width: 100%;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 1em;
    h2 {
      margin-top: unset;
    }

    #roadmap-h1 {
      grid-column-start: 1;
      grid-column-end: span 3;
      justify-self: center;
    }
  }
`
const ProjectColumns = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1em;
`


export default Projects